import React, { useState, useEffect } from 'react';
import SuccessPopup from '../../components/common/SuccessPopup';
import './Attendance.css';
import { TbFileText } from "react-icons/tb";
import { IoIosArrowBack } from "react-icons/io";
import config from '../../config';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { GrNotification } from "react-icons/gr";
import { LuCircleDollarSign } from "react-icons/lu";
import Header from "../../components/common/Header";
import logoImg from '../../icons/logo.jpg';



const PaySlip = ({ onCancel }) => {
  const [paySlipData, setPaySlipData] = useState([]);
  const [showSuccess, setShowSuccess] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');
  const [selectedClient, setSelectedClient] = useState('');
  const [clientList, setClientList] = useState([]);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const orgId = localStorage.getItem("orgId") || "";
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 7;
  const token = localStorage.getItem('Authorization') || '';
  console.log("formDate", fromDate.split("-")[1])

  const [logoBase64, setLogoBase64] = useState(null);

  useEffect(() => {
    const img = new Image();
    img.src = logoImg;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      setLogoBase64(canvas.toDataURL('image/jpeg'));
    };
  }, []);

  // Fetch client list and payslip data
  useEffect(() => {
    const fetchClientData = async () => {
      try {
        const url = await fetch(`${config.API_BASE_URL}${config.CLIENT_ENDPOINT}/${orgId}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        // const response = await url.json();
        const data = await url.json();
        console.log('Fetched client data:', data);
        setClientList(Array.isArray(data.body) ? data.body : []);
      } catch (error) {
        console.error('Error fetching client data:', error);
        setClientList([]);
      }
    };


    const fetchPaySlipData = async () => {
      if (!selectedClient) return;
      const fromDateYear = fromDate.split("-")[0];
      const fromDateMonth = fromDate.split("-")[1];
      const toDateYear = toDate.split("-")[0];
      const toDateMonth = toDate.split("-")[1];
      const fromdateDynamic = fromDateMonth && fromDateYear ? `&month=${fromDateMonth}&year=${fromDateYear}` : '';
      const toDateDynamic = toDateMonth && toDateYear ? `&toMonth=${toDateMonth}&toYear=${toDateYear}` : '';

      try {
        const url = await fetch(`${config.API_BASE_URL}${config.DASHBOARD_ENDPOINTATTENDANCE_PAYSLIP_LIST_ENDPOINT}?orgKey=${orgId}&clientKey=${selectedClient}${fromdateDynamic}${toDateDynamic}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        // const response = await fetch(url);
        const data = await url.json();
        console.log('Fetched payslip data:', data.body);

        const payslips = Array.isArray(data.body)
          ? data.body.map(item => ({
            ...item,
            employeeCode: item.employeeCode || item.empCode || item.empId, // pick the correct key
            selected: false
          }))
          : [];

        setPaySlipData(payslips);
      } catch (error) {
        console.error('Error fetching payslip data:', error);
        setPaySlipData([]);
      }
    };

    fetchClientData();
    fetchPaySlipData();
  }, [selectedClient, orgId, fromDate, toDate]);

  // Toggle single employee selection
  const handleToggleEmployee = (employeeCode, attendanceDate) => {
    setPaySlipData(prev =>
      prev.map(item =>
        item.employeeCode === employeeCode && item.attendanceDate === attendanceDate
          ? { ...item, selected: !item.selected }
          : item
      )
    );
  };

  const handleGeneratePaySlip = async () => {
    const selected = paySlipData.filter(emp => emp.selected);

    if (selected.length === 0) {
      setSuccessMsg('Please select at least one row.');
      setShowSuccess(true);
      return;
    }

    if (!fromDate) {
      setSuccessMsg("Please select From Date.");
      setShowSuccess(true);
      return;
    }

    // ✅ Extract month & year dynamically
    const dateObj = new Date(fromDate);
    const month = dateObj.getMonth() + 1; // 1-12
    const year = dateObj.getFullYear();

    try {
      for (const emp of selected) {

        const params = new URLSearchParams({
          orgKey: orgId,
          clientKey: selectedClient,
          employeeCodes: emp.employeeCode,
          month: month,
          year: year
        });

        const response = await fetch(
          `${config.API_BASE_URL}${config.ATTENDENCE_PAYSLIP_GENERATE_ENDPOINT}?${params.toString()}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
              "Cache-Control": "no-cache",
              Pragma: "no-cache",
            },
            cache: "no-store",
          }
        );

        const data = await response.json();
        console.log("Generate payslip response:", data);

        if (data.success === true) {
          generatePaySlipPDF(data?.body[0], emp);
        }
      }

      setSuccessMsg("Payslip generated successfully!");
      setShowSuccess(true);

      setPaySlipData(prev =>
        prev.map(emp => ({ ...emp, selected: false }))
      );

    } catch (error) {
      console.error("Error generating payslip:", error);
      setSuccessMsg("Failed to generate payslip. Please try again.");
      setShowSuccess(true);
    }
  };
  const generatePaySlipPDF = (data, emp) => {
    const doc = new jsPDF("p", "mm", "a4");
    const pageWidth = doc.internal.pageSize.getWidth();

    /* ---------------- HEADER ---------------- */
    if (logoBase64) {
      doc.addImage(logoBase64, "JPEG", 15, 10, 40, 22.5);
    }

    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text(localStorage.getItem("companyName")?.toUpperCase() || "WTILTH TECHNOLOGIES PRIVATE LIMITED", 60, 16, {
      align: "left",
    });

    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(100, 100, 100);
    doc.text("5th Ma, Fifth Main Rd, Gomathipuram,", 60, 22, { align: "left" });
    doc.text("Madurai, Tamil Nadu 625020", 60, 26, { align: "left" });

    doc.setFontSize(10);
    doc.text("Payslip For the Month", pageWidth - 15, 18, { align: "right" });
    
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(0, 0, 0);
    doc.text(
      `${data.month || "-"} ${data.year || new Date().getFullYear()}`,
      pageWidth - 15,
      24,
      { align: "right" }
    );

    doc.line(15, 34, pageWidth - 15, 34);

    /* ---------------- EMPLOYEE SUMMARY ---------------- */
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(100, 100, 100);
    doc.text("EMPLOYEE SUMMARY", 15, 42);

    doc.setFont("helvetica", "normal");
    doc.setTextColor(100, 100, 100);

    const startY = 49;
    const lineGap = 8;

    const summaryRows = [
      ["Employee Name", data.employeeName],
      ["Designation", data.designation || data.jobRole],
      ["Employee ID", data.employeeCode],
      ["Date of Joining", data.doj || "-"],
      ["Pay Period", `${data.month || "-"} ${data.year || new Date().getFullYear()}`],
      ["Pay Date", "-"],
    ];

    summaryRows.forEach((row, index) => {
      const y = startY + index * lineGap;
      doc.text(row[0], 15, y);
      doc.setTextColor(0, 0, 0);
      doc.text(`: ${row[1] ?? "-"}`, 55, y);
      doc.setTextColor(100, 100, 100);
    });
    doc.setTextColor(0, 0, 0);

    /* ---------------- RIGHT SALARY BOX ---------------- */
    const boxX = pageWidth - 75;
    const boxY = startY - 2;
    const boxWidth = 60;
    const boxHeight = 42;

    doc.setFillColor(230, 249, 230);
    doc.roundedRect(boxX, boxY, boxWidth, boxHeight, 3, 3, 'FD');
    doc.setTextColor(0, 0, 0);

    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text(
      `Rs. ${data.netSalary ?? 0}`,
      boxX + boxWidth / 2,
      boxY + 14,
      { align: "center" }
    );

    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");
    doc.text(`Paid Days`, boxX + 5, boxY + 28);
    doc.text(`: ${data.paidDays ?? 0}`, boxX + 35, boxY + 28);
    doc.text(`LOP Days`, boxX + 5, boxY + 34);
    doc.text(`: ${data.lopDays ?? 0}`, boxX + 35, boxY + 34);
    doc.text(`Deduction`, boxX + 5, boxY + 40);
    doc.text(`: Rs. ${data.totalDeduction ?? 0}`, boxX + 35, boxY + 40);

    /* ---------------- BANK & PAN INFO ---------------- */
    const infoY = startY + summaryRows.length * lineGap + 5;
    
    // Dotted line (approximated with small dashes or standard line for now)
    doc.setLineDashPattern([1, 1], 0);
    doc.line(15, infoY - 4, pageWidth - 15, infoY - 4);
    doc.setLineDashPattern([], 0); // Reset dash

    doc.setTextColor(100, 100, 100);
    doc.text("Bank Account No", 15, infoY + 2);
    doc.setTextColor(0, 0, 0);
    doc.text(": 922010026963284", 55, infoY + 2);

    doc.setTextColor(100, 100, 100);
    doc.text("UAN", boxX, infoY + 2);
    doc.setTextColor(0, 0, 0);
    doc.text(": 101668696406", boxX + 15, infoY + 2);
    
    doc.setTextColor(100, 100, 100);
    doc.text("PAN", boxX, infoY + 8);
    doc.setTextColor(0, 0, 0);
    doc.text(": BRAPG0501Q", boxX + 15, infoY + 8);

    /* ---------------- DIVIDER AFTER SUMMARY ---------------- */
    const summaryEndY = infoY + 14;
    doc.line(15, summaryEndY, pageWidth - 15, summaryEndY);

    /* ---------------- EARNINGS TABLE ---------------- */
    autoTable(doc, {
      startY: summaryEndY + 10,
      theme: "plain",
      head: [["EARNINGS", "AMOUNT"]],
      styles: { fontSize: 10 },
      headStyles: { fontStyle: "bold" },
      columnStyles: {
        0: { cellWidth: 90 },
        1: { cellWidth: 40, halign: "right" },
      },
      body: [
        ["BASIC", data.basicSalary ?? 0],
        ["HOUSE RENT ALLOWANCE", data.hra ?? 0],
        ["OTHERS", data.allowance ?? 0],
        ["GROSS EARNINGS", data.grossSalary ?? 0],
        ["TOTAL DEDUCTIONS", data.totalDeduction ?? 0],
        ["NET PAYABLE", data.netSalary ?? 0],
      ],
    });

    /* ---------------- AMOUNT IN WORDS ---------------- */
    const finalY = doc.lastAutoTable.finalY + 12;

    doc.line(15, finalY - 5, pageWidth - 15, finalY - 5);

    // Number to Words Converter (Indian System)
    const numberToWords = (num) => {
      if (!num || isNaN(num) || num === 0) return "ZERO";
      const a = ['', 'One ', 'Two ', 'Three ', 'Four ', 'Five ', 'Six ', 'Seven ', 'Eight ', 'Nine ', 'Ten ', 'Eleven ', 'Twelve ', 'Thirteen ', 'Fourteen ', 'Fifteen ', 'Sixteen ', 'Seventeen ', 'Eighteen ', 'Nineteen '];
      const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
      const inWords = (n) => {
        let str = '';
        if (n > 99) { str += a[Math.floor(n / 100)] + 'Hundred '; n %= 100; }
        if (n > 19) { str += b[Math.floor(n / 10)] + ' '; n %= 10; }
        if (n > 0) { str += a[n]; }
        return str;
      };
      let res = '';
      let n = Math.floor(Number(num));
      let y = Math.floor(n / 10000000);
      if (y > 0) res += inWords(y) + 'Crore ';
      n %= 10000000;
      y = Math.floor(n / 100000);
      if (y > 0) res += inWords(y) + 'Lakh ';
      n %= 100000;
      y = Math.floor(n / 1000);
      if (y > 0) res += inWords(y) + 'Thousand ';
      n %= 1000;
      if (n > 0) res += inWords(n);
      return res.trim() + " Rupees Only";
    };

    const netPayable = data.netSalary ?? 0;
    const wordsText = data.amountInWords || numberToWords(netPayable);

    doc.setFontSize(9);
    doc.text(
      `AMOUNT IN WORDS : ${wordsText.toUpperCase()}`,
      15,
      finalY
    );

    doc.line(15, finalY + 8, pageWidth - 15, finalY + 8);

    doc.setFontSize(8);
    doc.text(
      "This is a system-generated document.",
      pageWidth / 2,
      finalY + 18,
      { align: "center" }
    );

    /* ---------------- SAVE ---------------- */
    doc.save(`Payslip_${data.employeeCode || emp?.employeeCode}.pdf`);
  };






  // Download selected payslips as PDF
  const handleDownloadPDF = () => {
    const selected = paySlipData.filter(emp => emp.selected);
    if (selected.length === 0) {
      setSuccessMsg('Please select at least one row to download PDF.');
      setShowSuccess(true);
      return;
    }

    const doc = new jsPDF();
    doc.text('Employee Payslip', 14, 16);
    const tableColumn = [
      'Employee Name',
      'Date',
      'Check In',
      'Check Out',
      'Shift',
      'Employee WH',
      'Client WH'
    ];
    const tableRows = selected.map(emp => [
      emp.employeeName || '',
      emp.attendanceDate ? new Date(emp.attendanceDate).toLocaleDateString() : '',
      emp.checkIn || '',
      emp.checkOut || '',
      emp.shiftName || '',
      emp.workHours != null ? emp.workHours + ' hrs' : '',
      emp.clientWorkHours != null ? emp.clientWorkHours + ' hrs' : '',
      emp.employeeCode || ''
    ]);
    autoTable(doc, { head: [tableColumn], body: tableRows, startY: 22 });
    doc.save('payslip.pdf');
  };

  // Filtered and paginated data
  const filteredData = paySlipData.filter(item =>
    (item.employeeName || '').toLowerCase().includes(searchTerm.toLowerCase())
  );
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentPaySlips = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // Deselect all rows on page change
  useEffect(() => {
    setPaySlipData(prev => prev.map(emp => ({ ...emp, selected: false })));
  }, [currentPage]);

  // Bulk select/unselect
  const handleBulkToggle = () => {
    const allSelected = currentPaySlips.every(row => row.selected);
    setPaySlipData(prev =>
      prev.map(emp =>
        currentPaySlips.some(row => emp === row)
          ? { ...emp, selected: !allSelected }
          : emp
      )
    );
  };

  return (
    <div>
      <Header 
        title="Attendance List" 
        subtitle="All Attendance Pay Slip" 
        showBack={true} 
        onBack={onCancel} 
      />

      <div className='table-container'>
        {showSuccess && (
          <SuccessPopup
            message={successMsg}
            onClose={() => setShowSuccess(false)}
          />
        )}
        <div className='payslip-top-section'>
          <input
            type='text'
            className='search-input'
            placeholder='Search'
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ height: '15px' }}

          />

          <div className='payslip-filter-row'>
            <div className='payslip-filter-item'>
              <label className='payslip-filter-label'>Client</label>
              <select
                className='payslip-filter-select'
                value={selectedClient}
                onChange={(e) => setSelectedClient(e.target.value)}
              >
                <option value="">Select Client</option>
                {clientList.map((client) => (
                  <option key={client.clientKey} value={client.clientKey}>
                    {client.name}
                  </option>
                ))}
              </select>
            </div>

            <div className='payslip-filter-item'>
              <label className='payslip-filter-label'>From</label>
              <input
                type="date"
                className='payslip-filter-input'
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>

            <div className='payslip-filter-item'>
              <label className='payslip-filter-label'>To</label>
              <input
                type="date"
                className='payslip-filter-input'
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>

            <button className='payslip-generate-button' onClick={handleGeneratePaySlip}>
              <LuCircleDollarSign size={16} />
              Generate Pay Slip
            </button>
          </div>
        </div>

        <table className='table' style={{ marginTop: '20px' }}>
          <thead>
            <tr>
              <th className='th'>
                <button
                  className='payslip-bulk-status-btn'
                  style={{ padding: '2px 8px', fontSize: '12px', cursor: 'pointer' }}
                  onClick={handleBulkToggle}
                >
                  Bulk Status Update
                </button>
              </th>
              <th className='th'>Employee Name</th>
              <th className='th'>Date</th>
              <th className='th'>Check In</th>
              <th className='th'>Check Out</th>
              <th className='th'>Shift</th>
              <th className='th'>Employee WH</th>
              <th className='th'>Client WH</th>
            </tr>
          </thead>
          <tbody>
            {currentPaySlips.map((item, idx) => (
              <tr key={item.employeeCode + item.attendanceDate + idx}>
                <td className='td'>
                  <input
                    type="checkbox"
                    checked={item.selected}
                    onChange={() => handleToggleEmployee(item.employeeCode, item.attendanceDate)}
                  />

                </td>
                <td className='td'>{item.employeeName || ''}</td>
                <td className='td'>
                  {item.attendanceDate ? new Date(item.attendanceDate).toLocaleDateString() : ''}
                </td>

                <td className='td'>{item.checkIn || ''}</td>
                <td className='td'>{item.checkOut || ''}</td>
                <td className='td'>{item.shiftName || ''}</td>
                <td className='td'>{item.workHours != null ? item.workHours + ' hrs' : ''}</td>
                <td className='td'>{item.clientWorkHours != null ? item.clientWorkHours + ' hrs' : ''}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className='table-footer'>
          <div className='record-count'>
            Showing data {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredData.length)} of {filteredData.length} entries
          </div>

          <div className='pagination'>
            <button
              className='pagination-button'
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(currentPage - 1)}
            >
              &lt;
            </button>

            {(() => {
              const totalPages = Math.ceil(filteredData.length / itemsPerPage);
              let startPage = Math.max(1, currentPage - 1);
              let endPage = Math.min(totalPages, startPage + 2);
              if (endPage - startPage < 2) {
                startPage = Math.max(1, endPage - 2);
              }
              const pages = [];
              for (let i = startPage; i <= endPage; i++) {
                pages.push(
                  <button
                    key={i}
                    className={`pagination-button ${currentPage === i ? "active" : ""}`}
                    onClick={() => setCurrentPage(i)}
                  >
                    {i}
                  </button>
                );
              }
              return pages;
            })()}

            <button
              className='pagination-button'
              disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}
              onClick={() => setCurrentPage(currentPage + 1)}
            >
              &gt;
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaySlip;
